import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/free-delivery.svg")